// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';

// 获取留言信息
export const getValidMessage = (params) => {
    return getRequest('/cmsGuestbook/getValidByPage', params)
}

// 添加留言信息
export const addSaveVaileMessage = (params) => {
    return postRequest('/cmsGuestbook/saveOrUpdate',params)
}

// 获取vip信息的数据
export const goPersonOrEnterVip = (params) => {
    return getRequest('/registerVipConfig/findIndexPageShow', params)
}


// 法律服务侵权判定接口
export const getAddOrderInfringement = (params) => {
    return postRequest('/lawOrder/addInfringementDetermination',params)
}

// 法律服务出具律师函接口
export const getAddLawyerLetter = (params) =>{
    return postRequest('/lawOrder/addLawyerLetter',params)
}

// 法律服务侵权下架接口
export const getAddTortShelves = (params) =>{
    return postRequest('/lawOrder/addTortShelves',params)
}

// 法律服务合同审核接口/addContractAudit
export const getContractAudit = (params) =>{
    return postRequest('/lawOrder/addContractAudit',params)
}

// 获取华为云的token
export const getHuaWeiToken = (params) =>{
    return getRequest('/obs/sts/getAssumeRole',params)
}
//保险相关接口
// 分页获取保险信息
export const getInsurance = (params) =>{
    return getRequest('/insuranceOrder/getByPage',params)
}
//待保险存证/登记作品分页接口
export const getBuyInsurance = (params) =>{
    return getRequest('/insuranceOrder/getWorksByPage',params)
}
// 获取保单地址接口
export const getShangInsurance = (id,params) =>{
    return getRequest(`/insuranceOrder/getPolicyUrl/${id}`,params)
}
// 获取第三方保单填写地址接口
export const getInsuranceUrl = (params) =>{
    return postRequest('/insuranceOrder/getSubmitUrl',params)
}
// 获取电子发票地址接口
export const getInvioceInsurance = (id,params) =>{
    return getRequest(`/insuranceOrder/getInvoiceUrl/${id}`,params)
}
// 存证相关接口
// 分页获取存证信息
export const getOrderDownCert = (params) =>{
    return postRequest('/orderCommon/getByPage',params)
}
// 存证提交
export const getOrderJudicialDeposit = (params) =>{
    return postRequest('/orderCommon/judicialDeposit',params)
}
// 作品重复判断
export const getOrderWorksDulicate = (params) => {
    return getRequest('/orderCommon/worksDuplicate',params)
}
// 获取文件类型
export const getCertFileType = (params) =>{
    return getRequest('/config/getFileType',params)
}

// 法律服务电话问律师/addSope选择范围
export const getAddLawyerAddSope = (params) =>{
    return getRequest('/lawAskLawyer/addSope',params)
}

// 法律服务电话问律师/addChooseType选择类型
export const getAddLawyerAddChooseType = (params) =>{
    return getRequest('/lawAskLawyer/getTimeType',params)
}

// 法律服务电话问律师/addLawyer 下单
export const getAddLawyer = (params) =>{
    return postRequest('/lawOrder/addLawyer',params)
}

// 法律服务电话问律师/getTimeRange 时间范围选择
export const getTimeRange = (params) =>{
    return getRequest('/lawAskLawyer/getTimeRange',params)
}

// 动态登录获取验证码接口POST /bqjvip/user/sendSmsCode
export const postLoginSendSmsCode = (params) =>{
    return postRequest('/user/sendSmsCode',params)
}
// 动态登录接口POST /bqjvip/user/throughDynamicCode
export const postThroughDynamicCode = (params) =>{
    return postRequest('/user/throughDynamicCode',params)
}
// 注册时候判断是否已经注册GET /bqjvip/user/checkRegister
export const getCheckRegister = (params) =>{
    return getRequest('/user/checkRegister',params)
}
//GET /bqjvip/register/accountcenter/myorder 会员服务我的服务查询
export const getMemberMyOrder = (params) =>{
    return getRequest('/register/accountcenter/myorder',params)
}
// GET /bqjvip/registerVipConfig/find7daysVip
export const getSevenVip = (params) =>{
    return getRequest('/registerVipConfig/find7daysVip',params)
}
//POST /bqjvip/registerVipMemberApplication/save 免费试用/申请成为会员/续费
export const postMemberApplication = (params) =>{
    return postRequest('/registerVipMemberApplication/save',params)
}

// 个人中心，法律服务列表接口lawOrder/getByPage
export const getOrderCountsPage = (params) =>{
    return getRequest('/lawOrder/getByPage',params)
}

// 个人中心，法律服务详情接口1
export const getOrderDetailPage = (params) =>{
    return getRequest('/lawOrder/details',params)
}

// 个人中心，法律服务详情接口2
export const getOrderDetailPageTwo = (params) =>{
    return getRequest('/lawOrder/getOrderDetails',params)
}

// 我的存证重新提交接口 /bqjvip/orderCommon/resubmit
export const postResubmit = (params) =>{
    return postRequest('/orderCommon/resubmit',params)
}

// 获取会员剩余次数 GET /bqjvip/registerVipMemberRights/get
export const getVipMemberright = (params) =>{
    return getRequest('/registerVipMemberRights/get',params)
}
// 获取会员剩余次数 GET /bqjvip/registerVipMemberRights/get
export const getDeducTip = (params) =>{
    return getRequest('/notarial/enc/getDeducTip',params)
}
// 邮箱验证码获取 POST /bqjvip/user/sendEmailCode
export const postEmailCode = (params) =>{
    return postRequest('/user/sendEmailCode',params)
}
// 绑定邮箱接口 POST /bqjvip/user/emailBind
export const postEmailBind = (params) =>{
    return postRequest('/user/emailBind',params)
}

// 短信动态修改密码 POST /bqjvip/user/updatePassword
export const postUpdatePassword = (params) =>{
    return postRequest('/user/updatePassword',params)
}
// 修改头像接口 /user/modifyPicture
export const userModifyPicture = (params) =>{
    return postRequest('/user/modifyPicture',params)
}
// 修改用户昵称接口 /user/modifyName
export const userModifyName = (params) =>{
    return postRequest('/user/modifyName',params)
}

//获取时间接口
export const _sysGetTime = (params) =>{
    return getRequest('/config/getTime',params)
}

//定制 订单   /bqjvip/registerVipConfig/findOne
export const _getMadeOrder = (params)=>{
    return getRequest('/registerVipConfig/findOne',params)
}


//分页获取登记信息  /bqjvip/copyrightregister/otherservice/getByPage
export const getOtherService = (params)=>{
    return postRequest('/copyrightregister/otherservice/getByPage',params)
}

//申请纸质证书  /bqjvip/copyrightregister/otherservice/save
export const saveMyDciOrder = (params)=>{
    return postRequest('/copyrightregister/otherservice/save',params)
}


//版权家合伙人计划加盟
export const leavemessage = (params)=>{
    return postRequest('/hatch/ebaoquanLeavemessage/leavemessage',params)
}

//获取参与人数广告跑马灯
export const _getDictList = (params)=>{
    return getRequest('/config/getDictList',params)
}

// 短视频活动弹框提交接口    /bqjvip/cmsVideoConferenceGuests/join
export const _cmsVideoConferenceGuestsJoin = (params)=>{
    return postRequest('/cmsVideoConferenceGuests/join',params)
}

// 支付订单列表页
export const _getByPage = (params)=>{
    return postRequest('/registerVipMemberApplication/getByPage',params)
}